// Shared typography for the primary and secondary lines of cards shown in
// main-tab listings. Channel cards are the visual reference for these styles.
export const LIST_CARD_TITLE_CLASSES =
  'fc-list-card-title text-base leading-[1.2] font-bold text-gray-900 dark:text-gray-100';

export const LIST_CARD_SUBTITLE_CLASSES =
  'fc-list-card-subtitle mt-1 overflow-hidden text-xs leading-[1.5] font-normal text-gray-500 line-clamp-2 dark:text-gray-400';
